// Copyright (c) 2018 Deere & Company

import actions from '../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateDealershipModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.IS_DEALERSHIP_MODAL_VISIBLE
        });

    };



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/action-creators/is-dealership-modal-open.js